import { useSignatureSlotsQuery } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/api/useSignatureSlotsQuery.ts';
import { useUpdateMasterDocument } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/api/useUpdateMasterDocument.ts';
import type {
	PlacementAdapter,
	PlacementSaveArgs,
} from '@dealstack/frontend/shared/components/FieldBinding/placementAdapter.ts';

/**
 * Placement wired to a deal's master document. Module-level: its members are hooks, and each
 * is the one the editor called directly before — this is the seam, not a behaviour change.
 */
export const dealPlacementAdapter: PlacementAdapter = {
	useSlots: (templateId) => {
		const { data, isLoading, isError } = useSignatureSlotsQuery(templateId);
		return { data, isLoading, isError };
	},
	useSavePlacement: () => {
		const updateMasterDocument = useUpdateMasterDocument();
		return {
			save: async (args: PlacementSaveArgs) => {
				if (!args.templateId) {
					throw new Error('A master document is always saved before it is placed');
				}
				await updateMasterDocument.mutateAsync({
					templateId: args.templateId,
					useManualSignaturePlacement: args.useManualSignaturePlacement,
					showStampMetadata: args.showStampMetadata,
					signaturePlacements: args.signaturePlacements,
					requiresPostDating: args.requiresPostDating,
					datePlacements: args.datePlacements,
				});
			},
			isSaving: updateMasterDocument.isPending,
		};
	},
};
